







































import Vue from 'vue';
import { mapGetters } from 'vuex';

import BoxWrapper from '../../components/box-wrapper.vue';
import RegisterProgress from '../../components/register-progress.vue';
import CvPreview from '../../components/cv-preview.vue';
import * as RegistrationStore from '../../store/modules/register';
import * as ErrorStore from '../../store/modules/error';
import * as UiStore from '../../store/modules/ui';
import { makeMetaInfo } from '../../router/utils/meta';

export default Vue.extend({
  metaInfo: makeMetaInfo({ title: 'プレビュー' }),
  components: {
    BoxWrapper,
    RegisterProgress,
    CvPreview,
  },
  computed: {
    ...mapGetters(RegistrationStore.namespace, ['profileInfo']),
    ...mapGetters(ErrorStore.namespace, ['errors']),
    ...mapGetters(UiStore.namespace, ['isLoading']),
    profileImage() {
      return this.profileInfo.profile_image
        ? URL.createObjectURL(this.profileInfo.profile_image)
        : '//proff-local.s3-ap-northeast-1.amazonaws.com/images/default-profile-icon.png';
    },
  },
  mounted() {
    if (!this.profileInfo || !this.profileInfo.email) {
      this.$router.replace({ name: 'cv_path' });
    }
  },
  methods: {
    onSubmit() {
      this.$router.push({ name: 'user_path' });
    },
  },
});
